import { useTranslation } from 'react-i18next';

import { AlertsCell, CreditsCell, ValentinaCell, VersionCell } from './Dashboard.StatusCells';
import { styles } from './Dashboard.styles';
import type { StatusStripProps } from './Dashboard.types';

/** Valentina's own switch plus the three signals that decide whether to flip it. */
export const StatusStrip = ({ pause, pauseControl, dependencies, alerts, routing }: StatusStripProps) => {
	const { t } = useTranslation('translation', { keyPrefix: 'dashboard' });

	return (
		<section className={styles.statusStrip} aria-label={t('STATUS_STRIP_ARIA')}>
			<ValentinaCell pause={pause} pauseControl={pauseControl} />
			<CreditsCell dependencies={dependencies} />
			<AlertsCell alerts={alerts} />
			<VersionCell routing={routing} />
		</section>
	);
};
